import * as React from "react";

import StarSVG from "../../assets/Star"; 

export default function ProfessionalCard({ firstName, lastName, charge, reviewData, experience, profession, hourlyRate, imageUrl, selected, onClick, onContactClick, companyName }) {
    
  return (
    <div 
        className={`flex flex-col bg-white w-full md:w-[220px] rounded-xl ${selected ? 'border-2 border-shi-green' : 'border border-zinc-300 border-opacity-80'}`}
        onClick={onClick}
    >
      <div className={`flex rounded-t-xl bg-white min-h-[90px] h-[90px] py-1.5`}>
      {imageUrl && <img src={imageUrl} alt={`Company photo of ${companyName}`} className="w-full h-full object-contain rounded-t-xl" />}
      </div>
      <div className="flex flex-col border-t-[1px] border-slate-200 justify-center px-1.5 w-full md:w-full min-h-[90px] bg-[#F5F9FB] rounded-b-xl">
        <div className="flex flex-col w-full text-[14px] font-medium mt-2">
          <div className="inline-flex items-start justify-between w-full text-black">
            <div 
              className="truncate overflow-hidden whitespace-nowrap max-w-[120px]"
            >{companyName}</div>
            <div className="flex gap-0.5 items-center">
                <div className="self-stretch my-auto">{reviewData?.overallRating}</div>
                <StarSVG />
            </div>
          </div>
          <div className="mt-1 inline-flex items-center w-auto gap-1">
            <div className="text-zinc-500 font-light">{profession}</div>
            <div className="text-zinc-500 font-light px-1">|</div>
            <div className="text-zinc-500 font-light">{firstName + ' ' + lastName}</div>
          </div>
        </div>
        <div className="flex gap-4 justify-between items-center mt-3 mb-1 w-full whitespace-nowrap text-shi-deep-purple">
          <div className="inline-flex gap-1 items-end">
            <div className="my-auto text-[14px] font-bold w-auto">${charge?.chargeFee}</div>
            <div className="text-[12px] text-slate-600 align-bottom items-baseline">{charge?.chargeType}</div>
          </div>
          <button 
            className="gap-1.5 self-stretch px-2 py-1 my-auto text-[12px] font-medium text-center rounded-md border border-solid bg-white border-shi-green text-shi-green"
            onClick={onContactClick}
          >
            Contact
          </button>
        </div>
      </div>
    </div>
  );
}